import { useAuth } from "@clerk/clerk-react";
import { useEffect } from "react";
import { AuthScreen } from "@/auth";

/** Only same-origin targets, so `?redirect_url=` can't bounce hosts to another site. */
export function safeRedirectUrl(raw: unknown): string {
  const fallback = `${window.location.origin}/editor`;
  if (typeof raw !== "string" || !raw) return fallback;
  try {
    const url = new URL(raw, window.location.origin);
    return url.origin === window.location.origin ? url.href : fallback;
  } catch {
    return fallback;
  }
}

export function AuthPage({ mode, redirectUrl }: { mode: "sign-in" | "sign-up"; redirectUrl: string }) {
  const { isSignedIn } = useAuth();

  useEffect(() => {
    if (isSignedIn) window.location.replace(redirectUrl);
  }, [isSignedIn, redirectUrl]);

  if (isSignedIn) return null;
  return <AuthScreen mode={mode} redirectUrl={redirectUrl} />;
}
